import React, { useContext, useEffect, useState } from "react";
import { VehicleDto } from "../../../../dtos/catalogs/vehicle/VehicleDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import VehicleDetailSkeleton from "./VehicleDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import VehicleDetailMain from "./VehicleDetailMain";

interface IProps {
  model: VehicleDto | null;
  modelUpdatedEvent: (newModel: VehicleDto) => void;
}

interface VehicleModel {
  id: string;
  name: string;
  vehiclePlateNumber?: string;
  createdDate: Date;
}

export const VehicleDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<VehicleModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("createdDate", model.createdDate);
      setValue("vehiclePlateNumber", model.vehiclePlateNumber);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: VehicleModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: VehicleDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <VehicleDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
        <VehicleDetailMain/>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
